<template>
  <div
    class="captcha-input"
  >
    <vue-turnstile
      v-if="captchaSiteKey"
      :site-key="captchaSiteKey"
      :action="captchaAction"
      size="normal"
      v-model="token"
      @update:modelValue="handleTurnstileVerify"
      ref="turnstile"
    />
    <input
      type="hidden"
      name="captchaToken"
      :value="token"
    >
    <transition name="input-error--animation">
      <span
        class="input-error"
        v-if="error"
        v-html="error"
      />
    </transition>
  </div>
</template>

<script lang="ts">
  import {defineComponent, ref} from 'vue';
  import VueTurnstile from 'vue-turnstile';

  export default defineComponent({
    name: 'CaptchaInput',
    components: {VueTurnstile},

    props: {
      captchaSiteKey: {
        type: String,
        required: true
      },
      captchaAction: {
        type: String,
        default: '',
        required: false
      },
      error: {
        type: String,
        default: ''
      },
    },

    emits: ['change', 'update:modelValue'],

    setup(props, context) {
      const token = ref('');

      function handleTurnstileVerify(turnstileToken: string) {
        token.value = turnstileToken;
        context.emit('change', turnstileToken);
        context.emit('update:modelValue', turnstileToken);
      }

      function execute(): Promise<{ response: string, key: string }> {
        if (token.value) {
          return new Promise((resolve) => {
            resolve({
              response: 'ok',
              key: token.value
            });
          })
        } else {
          return new Promise((resolve) => {
            resolve({
              response: 'error',
              key: ''
            });
          });
        }
      }

      function reset() {
        const turnstile = this.$refs.turnstile;

        if (turnstile !== undefined) {
          turnstile.reset();
          token.value = '';
          return;
        }
      }

      context.expose({
        token,
        execute,
        reset,
      })

      return {
        token,
        handleTurnstileVerify,
        execute,
        reset
      }
    },
  });
</script>
